export default [
  {
    path: '/businesses/orders',
    name: 'food-orders-list',
    component: () => import('@/views/businesses/pages/orders/List.vue'),
    meta: {
      resource: 'businesses-orders',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Orders',
      breadcrumb: [
        {
          text: 'Orders',
          active: true,
        },
      ],
    },
  },
  {
    path: '/businesses/orders/:id',
    name: 'food-order-details',
    component: () => import('@/views/businesses/pages/orders/OrderDetails.vue'),
    meta: {
      resource: 'businesses-orders',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Order Details',
      breadcrumb: [
        {
          text: 'Order Details',
          to: '/businesses/orders',
        },
      ],
    },
  },
  {
    path: '/businesses/tags',
    name: 'businesses-tags',
    component: () => import('@/views/businesses/pages/tags/List.vue'),
    meta: {
      resource: 'businesses-tags',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Tags',
      breadcrumb: [
        {
          text: 'Tags',
          active: true,
        },
      ],
    },
  },
  {
    path: '/businesses/list',
    name: 'businesses-list',
    component: () => import('@/views/businesses/pages/BusinessesList.vue'),
    meta: {
      resource: 'businesses-list',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Businesses',
      breadcrumb: [
        {
          text: 'Businesses',
          active: true,
        },
      ],
    },
  },
  {
    path: '/businesses/pending-approvals',
    name: 'businesses-pending-approvals',
    component: () => import('@/views/businesses/pages/PendingApprovals.vue'),
    meta: {
      resource: 'businesses-pending-approvals',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Pending Approvals',
      breadcrumb: [
        {
          text: 'Pending Approvals',
          active: true,
        },
      ],
    },
  },
  {
    path: '/businesses/:id/pending-approvals',
    name: 'business-pending-approvals',
    component: () => import('@/views/businesses/pages/BusinessPendingDetails.vue'),
    meta: {
      resource: 'businesses-pending-approvals',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Pending Approvals',
      breadcrumb: [
        {
          text: 'Pending Approvals',
          to: '/businesses/pending-approvals',
        },
      ],
    },
  },
  {
    path: '/businesses/food/details/:id',
    name: 'businesses-food-details',
    component: () => import('@/views/businesses/pages/RestaurantDetails.vue'),
    meta: {
      resource: 'businesses-list',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Restaurant Details',
      breadcrumb: [
        {
          text: 'Businesses',
          to: '/businesses/list',
        },
      ],
    },
  },
  {
    path: '/businesses/ride-hailing/details/:id',
    name: 'businesses-ride-hailing-details',
    component: () => import('@/views/businesses/pages/RideHailingDetails.vue'),
    meta: {
      resource: 'businesses-list',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Ride Hailing Details',
      breadcrumb: [
        {
          text: 'Businesses',
          to: '/businesses/list',
        },
      ],
    },
  },
  {
    path: '/businesses/fleet-management/details/:id',
    name: 'businesses-fleet-management-details',
    component: () => import('@/views/businesses/pages/FleetManagementDetails.vue'),
    meta: {
      resource: 'businesses-list',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Fleet Management Details',
      breadcrumb: [
        {
          text: 'Businesses',
          to: '/businesses/list',
        },
      ],
    },
  },
  {
    path: '/businesses/create',
    name: 'businesses-create',
    component: () => import('@/views/businesses/pages/CreateBusiness.vue'),
    meta: {
      resource: 'businesses-list',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Create Business',
      breadcrumb: [
        {
          text: 'Businesses',
          to: '/businesses/list',
        },
      ],
    },
  },
  {
    path: '/businesses/document-types',
    name: 'businesses-document-types',
    component: () => import('@/views/businesses/pages/DocumentTypesList.vue'),
    meta: {
      resource: 'businesses-document-types',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Document Types',
      breadcrumb: [
        {
          text: 'Document Types',
          active: true,
        },
      ],
    },
  },
  {
    path: '/businesses/types',
    name: 'businesses-types',
    component: () => import('@/views/businesses/pages/business-types/List.vue'),
    meta: {
      resource: 'businesses-types',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Business Types',
      breadcrumb: [
        {
          text: 'Business Types',
          active: true,
        },
      ],
    },
  },
  {
    path: '/businesses/heros',
    name: 'businesses-heros',
    component: () => import('@/views/businesses/pages/heros/List.vue'),
    meta: {
      resource: 'businesses-heros',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Heros',
      breadcrumb: [
        {
          text: 'Heros',
          active: true,
        },
      ],
    },
  },
  {
    path: '/businesses/heros/new',
    name: 'businesses-heros-new',
    component: () => import('@/views/businesses/pages/heros/CreateNewHero.vue'),
    meta: {
      resource: 'businesses-heros',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'New Hero',
      breadcrumb: [
        {
          text: 'Heros',
          to: '/businesses/heros',
        },
      ],
    },
  },
  {
    path: '/businesses/heros/edit/:id',
    name: 'businesses-heros-edit',
    component: () => import('@/views/businesses/pages/heros/EditHero.vue'),
    meta: {
      resource: 'businesses-heros',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Edit Hero',
      breadcrumb: [
        {
          text: 'Heros',
          to: '/businesses/heros',
        },
      ],
    },
  },
  {
    path: '/businesses/versions/prepare-pricing',
    name: 'businesses-versions-prepare',
    component: () => import('@/views/businesses/pages/ride-hailing-pricing-config/RideHailingPreparePricing.vue'),
    meta: {
      resource: 'versions',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Versions',
      // breadcrumb: [
      //   {
      //     text: 'Pricing Configuration',
      //     to: '/pricing-config',
      //   },
      // ],
    },
  },
  {
    path: '/businesses/versions/new',
    name: 'businesses-versions-new',
    component: () => import('@/views/businesses/pages/ride-hailing-pricing-config/RideHailingAddVersion.vue'),
    meta: {
      resource: 'versions',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Versions',
      // breadcrumb: [
      //   {
      //     text: 'Pricing Configuration',
      //     to: '/pricing-config',
      //   },
      // ],
    },
  },
  {
    path: '/businesses/versions/edit/:id',
    name: 'businesses-versions-edit',
    component: () => import('@/views/businesses/pages/ride-hailing-pricing-config/RideHailingEditVersion.vue'),
    meta: {
      resource: 'versions',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Versions',
      // breadcrumb: [
      //   {
      //     text: 'Pricing Configuration',
      //     to: '/pricing-config',
      //   },
      // ],
    },
  },
]
